module.exports = __webpack_public_path__ + "static/sandg-42ebb499339a16b9e8de6a33c7cef912.png";